import Notifications from './NotificationsComponent.vue';

const NotificationStore = {
  state: <any[]>[], // here the notifications will be added

  removeNotification(timestamp: any) {
    const indexToDelete = this.state.findIndex(n => n.timestamp === timestamp);
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addNotification(notification: any) {
    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(notification.timestamp.getMilliseconds() + this.state.length);
    this.state.push(notification);
  },
  notify(notification: any) {
    if (Array.isArray(notification)) {
      notification.forEach(notificationInstance => {
        this.addNotification(notificationInstance);
      });
    } else {
      this.addNotification(notification);
    }
  },
};

const NotificationsPlugin = {
  install(Vue: any) {
    Vue.mixin({
      data() {
        return {
          notificationStore: NotificationStore,
        };
      },
      methods: {
        notify(this: any, notification: any) {
          this.notificationStore.notify(notification);
        },
      },
    });
    Object.defineProperty(Vue.prototype, '$notify', {
      get() {
        return this.$root.notify;
      },
    });
    Object.defineProperty(Vue.prototype, '$notifications', {
      get() {
        return this.$root.notificationStore;
      },
    });
    Vue.component('NotificationsComponent', Notifications);
  },
};

export default NotificationsPlugin;
